/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import DashboardLayout from '@/views/Layout/DashboardLayout.vue';
import { NavigationGuardNext, Route, RouteConfig } from 'vue-router';
import { checkPermissions } from '../routeValidation';
import {
  checkPermissionsAndCommpixCredentials,
  checkPermissionsAndMasspaymentCredentials,
  checkPermissionsAndCommpixOrMantecaCredentials
} from '../routeGuards';
import {
  dinamicPaymentPermission,
  historyTransactionPermission,
  salesReportPermission,
  scanToPayPermission,
  bolepixPermissions,
  dailyTransactionsStatementPermissions,
  payinsQrPermissions,
  transferencesPermissions
} from './permissions';
import { ROUTES } from './routes';
import { NAVBAR_TYPE_LIGHT } from '@/util/constants/config';

const {
  SALES_REPORT,
  TRANSACTION_HISTORY, DAILY_TRANSACTIONS_STATEMENT,
  SCAN_TO_PAY, DINAMIC_PAYMENTS,
  BOLEPIX_COMMPIX,
  QR_PAYINS_COMMPIX,
  TRANSFERENCES,
} = ROUTES;

const TransactionHistory = () =>
  import(
    /* webpackChunkName: "TransactionHistory" */
    '@/views/Sales/Transactions.vue'
  );

const SalesResport = () =>
  import(
    /* webpackChunkName: "SalesReportHome" */
    '@/views/Sales/SalesReport.vue'
  );

const transactionHistoryRoute: RouteConfig = {
  path: '/',
  component: DashboardLayout,
  children: [
    {
      path: TRANSACTION_HISTORY.route,
      name: TRANSACTION_HISTORY.name,
      component: TransactionHistory,
      beforeEnter(to: Route, from: Route, next: NavigationGuardNext<Vue>) {
        checkPermissions(to, from, next);
      },
      meta: {
        navbarType: NAVBAR_TYPE_LIGHT,
        permissions: historyTransactionPermission,
      },
    },
    {
      path: SALES_REPORT.route,
      name: SALES_REPORT.name,
      component: SalesResport,
      meta: {
        navbarType: NAVBAR_TYPE_LIGHT,
        permissions: salesReportPermission,
      },
    },
    {
      path: DAILY_TRANSACTIONS_STATEMENT.route,
      name: DAILY_TRANSACTIONS_STATEMENT.name,
      component: () =>
        import(
          /* webpackChunkName: "DailyTransactionsStatement" */
          '@/views/Sales/DailyTransactionsStatement.vue'
        ),
      beforeEnter: checkPermissionsAndCommpixCredentials,
      meta: {
        navbarType: NAVBAR_TYPE_LIGHT,
        permissions: dailyTransactionsStatementPermissions,
      },
    },
    {
      path: SCAN_TO_PAY.route,
      name: SCAN_TO_PAY.name,
      component: () =>
        import(
          /* webpackChunkName: "ScanToPay" */
          '@/views/Sales/ScanToPay.vue'
        ),
      beforeEnter: checkPermissionsAndCommpixOrMantecaCredentials,
      meta: {
        navbarType: NAVBAR_TYPE_LIGHT,
        permissions: scanToPayPermission,
      },
    },
    {
      path: DINAMIC_PAYMENTS.route,
      name: DINAMIC_PAYMENTS.name,
      component: () =>
        import(
          /* webpackChunkName: "RemotePayments.vue" */
          '@/views/Sales/DinamicsPayments.vue'
        ),
      beforeEnter: checkPermissionsAndCommpixCredentials,
      meta: {
        navbarType: NAVBAR_TYPE_LIGHT,
        permissions: dinamicPaymentPermission,
      },
    },
    {
      path: BOLEPIX_COMMPIX.route,
      name: BOLEPIX_COMMPIX.name,
      component: () =>
        import(
          '@/views/Sales/Bolepix.vue'
        ),
      beforeEnter: checkPermissionsAndCommpixCredentials,
      meta: {
        navbarType: NAVBAR_TYPE_LIGHT,
        permissions: bolepixPermissions,
      },
    },
    {
      path: QR_PAYINS_COMMPIX.route,
      name: QR_PAYINS_COMMPIX.name,
      component: () =>
        import(
          '@/views/Sales/QrPayins.vue'
        ),
      beforeEnter: checkPermissionsAndMasspaymentCredentials,
      meta: {
        navbarType: NAVBAR_TYPE_LIGHT,
        permissions: payinsQrPermissions,
      },
    },
    {
      path: TRANSFERENCES.route,
      name: TRANSFERENCES.name,
      component: () =>
        import(
          /* webpackChunkName: "Transferences" */
          '@/views/Sales/Transferences.vue'
        ),
      meta: {
        navbarType: NAVBAR_TYPE_LIGHT,
        permissions: transferencesPermissions,
      },
    }
  ],
};
export default transactionHistoryRoute;
